import React from 'react';
import { isImage, isPDF } from '../../../utils/documents';
import PDFViewer from '../shipments/PDFViewer';

export function DocumentsPreview({ files, placeholder = '' }) {
  return (
    <div>
      {files.map((file, index) => {
        let fileType = file.type;

        if (isPDF(fileType)) {
          return (
            <div key={index}>
              <PDFViewer file={file} />
            </div>
          );
        }

        if (isImage(fileType)) {
          return (
            <div key={index}>
              <img
                width="100%"
                height="100%"
                alt="Preview"
                src={file.preview ? file.preview : placeholder}
              />
            </div>
          );
        }

        return <div key={index}>{file.name || placeholder}</div>;
      })}
    </div>
  );
}
